import React from 'react'
import { Translate } from '../../../language'
import Button from '../../../utils/components/Button/Button'
import style from './CardOil.module.css'

const CardOil = ({text, onClick, Icon}) => {
    
  return (
    <div className={style.content_card_oil}>
      <div className={style.content_img_card_oil} onClick={onClick}>
        <Icon className={style.img_card_oil} />
      </div>

      <div className={style.content_name_card_oil} onClick={onClick}>
        <div className={style.text_card_oil}>
          {text}
        </div>
         
        <div className="text-two-card-oil">
          <Button onClick={() => {
          }} theme="white" text={Translate('getInto', 'es')} />
        </div>
      </div>
    </div>
  )
}

export default CardOil